import React, { useEffect, useState, useRef, useCallback } from "react";
import ReactDOM from "react-dom";
import { modalEventListener } from "../../../utils/ModalEventListener";
import { axios_instance } from "../../../api/axios_instance";
import { convertToUTCFormat } from "../../../utils/format";
import ContainerLoading from "../../../layouts/ContainerLoading";
import ModalWrapper from "../../../layouts/ModalWrapper";
import { format } from "date-fns";

const RemarksModal = ({
  showRemarkTextArea,
  remarkModalProps,
  fetchListData,
  closeRemarksModal,
  showRemarksModal,
}) => {
  const { finance_lead_id, disbursement_id, idx } = remarkModalProps;
  const initialState = { remarks: [], remark: "" };
  const [state, setState] = useState(initialState);
  const [isLoading, setIsLoading] = useState(false);

  const ref = useRef();

  useEffect(() => {
    return modalEventListener(ref, closeRemarksModal);
  }, [closeRemarksModal]);

  const fetchRemarksData = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await axios_instance({
        url: "/wp/getRemarksData",
        method: "POST",
        data: { disbursement_id },
      });
      if (response.status === 200) {
        setState((prevState) => ({
          ...prevState,
          remarks: response.data.result,
        }));
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  }, [disbursement_id]);

  useEffect(() => {
    if (showRemarksModal) fetchRemarksData();
  }, [fetchRemarksData]);

  const saveWithheldRemarks = async () => {
    if (!state.remark) {
      window.alert("Please enter remarks");
      return;
    }

    if (window.confirm("Would you like to proceed?")) {
      setIsLoading(true);
      try {
        await axios_instance({
          url: "/wp/saveRemarks",
          method: "POST",
          data: {
            finance_lead_id,
            disbursement_id,
            remark: state.remark,
            stage: 1,
            sub_stage: 4,
            action: "save_withheld_remark",
          },
        });
        setIsLoading(false);
        await fetchListData(false, true, finance_lead_id);
      } catch (error) {
      } finally {
        setIsLoading(false);
      }
    }
  };

  return ReactDOM.createPortal(
    <ModalWrapper show={showRemarksModal} onClose={closeRemarksModal}>
      <div className="modal-wrapper">
        <div className="remarks-modal-content" ref={ref}>
          <div className="modal-header">
            <button type="button" className="close">
              <span aria-hidden="true" onClick={closeRemarksModal}>
                &times;
              </span>
            </button>
            <h4 className="modal-title" id="">
              Remarks
            </h4>
          </div>
          <div className="modal-body clearfix">
            {!isLoading ? (
              <>
                {!state?.remarks?.length ? "No Remarks !" : ""}
                {state?.remarks.map((remark, idx) => {
                  return (
                    <div className="row" key={idx}>
                      <div className="col-md-12 popup-comments">
                        {remark.remark}
                      </div>
                      <div className="col-md-12 popup-dates">{`by ${
                        remark.username
                      } on ${format(
                        new Date(
                          remark.added_at ? remark.added_at : "0000:00:00"
                        ),
                        "yyyy-MM-dd kk:mm:ss"
                      )}`}</div>
                    </div>
                  );
                })}
              </>
            ) : (
              <ContainerLoading />
            )}

            <div className="row mrg-T15">
              <div className="col-md-12">
                {showRemarkTextArea && showRemarkTextArea[idx] ? (
                  <textarea
                    id="withheld_remark"
                    className="form-control"
                    style={{ height: "90px" }}
                    onChange={(e) =>
                      setState({ ...state, remark: e.target.value })
                    }
                  ></textarea>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
          <div className="modal-footer text-center">
            {showRemarkTextArea && showRemarkTextArea[idx] ? (
              <button
                type="button"
                className="btn rc-btn_primary btn-lg"
                onClick={saveWithheldRemarks}
              >
                Save
              </button>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </ModalWrapper>,
    document.querySelector(".myPortalModalDiv")
  );
};

export default RemarksModal;
